import { useParams } from 'react-router-dom';
import { List } from '../../../../../../../../commonComponents/CardList';
import { useOfficesCard } from '../hooks';
import { OfficeItem } from './OfficeItem';

export const OfficeList = () => {
  const { id: dsoId } = useParams();
  const { data, handleScrollList, isInitialLoading, isLoading } = useOfficesCard(dsoId);

  return (
    <List
      data={data}
      onScroll={handleScrollList}
      renderItem={({ item }) => <OfficeItem dsoId={dsoId} item={item} />}
      isLoading={isInitialLoading || isLoading}
    />
  );
};
